import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GmapsAddress from "../../../common/Map/GmapsAddress";
import WithGoogleApi from "../../../common/Map/WithGoogleApi";
import {
  getProfileDetailPopupAction,
  getProviderProfileDetailAction,
} from "../../../redux/actions/ProviderProfileDetailAction";
import Geocode from "react-geocode";
import { ApproveRejectButton, initialFilterState } from "./helper";
import { getNetworkMenuId } from "../../../Utils/types";

export const ProfileDetailPopup = ({
  rowData,
  searchFilter,
  apiParams,
  setRowData,
}) => {
  const dispatch = useDispatch();
  const [remark, setRemark] = useState("");
  Geocode.setApiKey("AIzaSyAy9gYbxqSCIe2BFo46GcNAk81zP-t7ZGA");
  const [streetAddr, setStreetAddr] = useState(null);
  const [isOpenLocationPopup, setIsOpenLocationPopup] = useState(false);

  const getViewDetailPage = useSelector(
    (state) =>
      state?.providerPortalDetailReducer?.getViewDetailPage
        ?.networkUserProfileDetail?.[0]
  );

  useEffect(() => {
    dispatch(
      getProfileDetailPopupAction(rowData?.requestID, rowData?.sessionID)
    );
  }, []);

  useEffect(() => {
    if (
      getViewDetailPage?.providerLatitude !== 0 ||
      getViewDetailPage?.providerLongitude !== 0
    ) {
      Geocode.fromLatLng(
        getViewDetailPage?.providerLatitude,
        getViewDetailPage?.providerLongitude
      ).then((response) => {
        const address = response.results[0].formatted_address;
        setStreetAddr({
          caption: address,
          heart: {
            lat: getViewDetailPage?.providerLatitude,
            lng: getViewDetailPage?.providerLongitude,
          },
        });
      });
    }
  }, [getViewDetailPage]);

  return (
    <>
      <div className="___parent_container d-flex justify-content-between border-bottom modalHeader">
        <div className="d-flex align-items-center gap-10">
          <div className="logo-circle">
            <img src={rowData?.providerLogo} alt="" />
          </div>
          <div className="brand-name">
            <h5 className="mb-0 text-highlight font-bold">
              {rowData?.providerName}
            </h5>
          </div>
        </div>
        <div className="align-items-center gap-3 d-flex">
          <h5 className="mb-0 text-highlight font-bold">
            <span style={{color:"black"}}>Action : </span>{getViewDetailPage?.source}
          </h5>
        <button
          type="button"
          className="btn-close normal-close"
          onClick={async () => {
            await setRemark("");
            await setRowData(null);
            if (getViewDetailPage === undefined) {
              await dispatch(
                getProviderProfileDetailAction(initialFilterState)
              );
            }
          }}
        ></button>
        </div>
      </div>
      <div className="___parent_container modal-body">
        <h4
          className="font-bold text-highlight mb-4"
          style={{ letterSpacing: "1px" }}
        >
          Profile Details
        </h4>
        <div className="card-container d-flex justify-content-between gap-30">
          <div className="cards padding-0">
            <div className="pdetails padding-30">
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Centre Name</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.providerName}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Display Name</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.displayProviderName}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Area Name</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.areaName}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Year Establishment</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.yearEstablish}
                </div>
              </div>
              <div className="d-flex justify-content-between bottom-spacing-10 align-items-center">
                <div className="font-bold">Centre Type</div>
                <div className="font-medium text-highlight d-flex gap-10">
                  <div
                    className={
                      getViewDetailPage?.centerType === "DC"
                        ? "pill-highlighted"
                        : "pill-un-highlighted"
                    }
                  >
                    Diagnostics Centre
                  </div>
                  <div
                    className={
                      getViewDetailPage?.centerType === "HOSP"
                        ? "pill-highlighted"
                        : "pill-un-highlighted"
                    }
                  >
                    Hospital
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between bottom-spacing-10 align-items-center">
                <div className="font-bold">Visit Type</div>
                <div className="font-medium text-highlight d-flex gap-10">
                  <div
                    className={
                      getViewDetailPage?.visitSupport === "HV"
                        ? "pill-highlighted"
                        : "pill-un-highlighted"
                    }
                  >
                    Home Visit
                  </div>
                  <div
                    className={
                      getViewDetailPage?.visitSupport === "DC"
                        ? "pill-highlighted"
                        : "pill-un-highlighted"
                    }
                  >
                    Centre Visit
                  </div>
                  <div
                    className={
                      getViewDetailPage?.visitSupport === "MIX"
                        ? "pill-highlighted"
                        : "pill-un-highlighted"
                    }
                  >
                    Mix Visit
                  </div>
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Authorized Person Name</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.authorizedPersonName}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Registered Mobile Number</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.registeredMobileNo}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Whatsapp Number</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.additionalMobileNo}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Registered Email Address</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.registeredEmailID}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Official Website</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.officialWebsite}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Permanent Address</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.houseNumber}
                  {getViewDetailPage?.houseNumber && ","}
                  {getViewDetailPage?.houseName}
                  {getViewDetailPage?.houseName && ","}
                  {getViewDetailPage?.address1}
                  {getViewDetailPage?.address1 && ","}
                  {getViewDetailPage?.address2}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">City</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.city}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">State / Province</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.stateName}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Pincode</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.pincode}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Landmark</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.landmark}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Google My Business Link</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.googleMyBusinessLink}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Practo Link</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.practoLink}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">BajajFinserv Link</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.bajajFinservLink}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">GetVisit Link</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.getVisitLink}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">EkaCare Link</div>
                <div className="font-medium text-highlight">
                  {getViewDetailPage?.ekaCareLink}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Locate On Google Map</div>
                <div className="font-medium text-highlight">
                  {(getViewDetailPage?.providerLatitude !== 0 ||
                    getViewDetailPage?.providerLongitude !== 0) && (
                    <a
                      className="text-decoration"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#current-location-popup"
                      onClick={() => setIsOpenLocationPopup(true)}
                    >
                      View
                    </a>
                  )}
                </div>
              </div>
            </div>
            <div className="spacing-hr mt-0"></div>
          </div>
          <div className="cards d-flex flex-direction-column justify-content-between __branch_details">
            <div>
              <h5 className="font-bold text-black bottom-spacing-20 mb-5">
                Remarks
              </h5>
              <textarea
                className="textarea font-medium m-12-"
                placeholder="Type Something Here..."
                value={
                  rowData?.requestStatus !== "Pending for Approval"
                    ? rowData?.remarks
                    : remark
                }
                onChange={(e) => setRemark(e.target.value)}
                disabled={
                  rowData?.requestStatus !== "Pending for Approval" ||
                  !getNetworkMenuId()?.canEdit
                }
              ></textarea>
            </div>
            <div className="accept-reject-btns bottom-0">
              {rowData?.requestStatus === "Pending for Approval" &&
                getNetworkMenuId()?.canEdit && (
                  <ApproveRejectButton
                    rowData={rowData}
                    setRowData={setRowData}
                    remark={remark}
                    setRemark={setRemark}
                    searchFilter={searchFilter}
                    apiParams={apiParams}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="current-location-popup"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Locate on Google Map</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setIsOpenLocationPopup(false)}
              ></button>
            </div>
            {isOpenLocationPopup && (
              <>
                <div className="modal-body">
                  <div className="row mb-4 align-items-end">
                    <label className="form-label mt-4">Search</label>
                  </div>
                  <div>
                    <WithGoogleApi>
                      <GmapsAddress
                        value={streetAddr}
                        onChange={setStreetAddr}
                      />
                    </WithGoogleApi>
                  </div>
                </div>
                <div className="modal-footer"></div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
